
import lazyload from "@/directives/lazyload";
import logo from "@/assets/images/landing/svg/big-logo.svg";
export default {
  data() {
    return {
      displaySearches: "2310854",
      displayFound: "693256",
      images: {
        logo,
      },
    };
  },
  directives: {
    lazyload,
  },
  mounted() {
    this.outNumSearches(2310854, 2135);
    this.outNumFound(693256, 862);
    this.myWindow = window;
  },
  methods: {
    outNumSearches(num, step) {
      var time = 100000;
      var n = 325664;
      var t = Math.round(time / (num / step));
      let interval = setInterval(() => {
        n = n + step;
        this.displaySearches = n;
        if (n >= num) {
          clearInterval(interval);
        }
      }, t);
    },
    outNumFound(num, step) {
      var time = 70000;
      var n = 96332;
      var t = Math.round(time / (num / step));
      let interval = setInterval(() => {
        n += step;
        this.displayFound = n;
        if (n >= num) {
          clearInterval(interval);
        }
      }, t);
    },
  },
};
